import { IsNotEmpty, IsInt, IsOptional, IsString, IsEnum, IsDateString, Min, Max } from 'class-validator';
import { TestingStatus } from '../../enums/confirmatory-testing';

export class CreateYearlyTestRecordRequestDto {
    /**
     * Testing year
     * @example 2025
     */
    @IsNotEmpty()
    @IsInt()
    @Min(2000)
    @Max(2100)
    year: number;

    /**
     * Lot number for the test
     * @example '(L) 2022945'
     */
    @IsOptional()
    @IsString()
    lotNumber?: string;

    /**
     * Bulk lot number
     * @example '(Bulk (L) 2H004A)'
     */
    @IsOptional()
    @IsString()
    bulkLotNumber?: string;

    /**
     * Testing status
     * @example 'Complete'
     */
    @IsNotEmpty()
    @IsEnum(TestingStatus)
    testingStatus: TestingStatus;

    /**
     * Date when the test is scheduled
     * @example '2025-03-15'
     */
    @IsOptional()
    @IsDateString()
    scheduledDate?: string;

    /**
     * Date when testing was completed
     * @example '2025-03-15'
     */
    @IsOptional()
    @IsDateString()
    testingCompleteDate?: string;

    /**
     * Additional notes
     * @example 'testing complete in 2024'
     */
    @IsOptional()
    @IsString()
    notes?: string;
}


